export const LIFESTYLE_PRODUCT = {
  TRUE: 'true',
  FALSE: 'false',
  TRUE_WITH_EXCEPTIONS: 'true_with_exceptions',
}
